import moment from "moment";
import { encryptionPass } from "../config/Config";
import CryptoJS from "crypto-js";

export const encryptPayload = (payload: unknown) => {
  // any object properties must only be primitive
  const data = JSON.stringify(payload);

  const salt = CryptoJS.lib.WordArray.random(128 / 8); // Generate a random salt
  const key = CryptoJS.PBKDF2(encryptionPass, salt, {
    keySize: 256 / 32,
    iterations: 1000,
  });
  const iv = CryptoJS.lib.WordArray.random(128 / 8); // Generate a random IV

  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
  });

  // Combine salt, iv, and encrypted data for storage
  const result =
    salt.toString() + ":" + iv.toString() + ":" + encrypted.toString();
  return result;
};

export const encryptPayloadV2 = (payload: unknown) => {
  const date = moment().format("x"); // Add date to the payload;
  let data = JSON.stringify(payload);
  data += `|:|${date}`;

  const salt = CryptoJS.lib.WordArray.random(128 / 8); // Generate a random salt

  const key = CryptoJS.PBKDF2(encryptionPass, salt, {
    keySize: 256 / 32,
    iterations: 1000,
  });
  const iv = CryptoJS.lib.WordArray.random(128 / 8); // Generate a random IV

  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
  });

  // Combine salt, iv, and encrypted data for storage
  const result =
    salt.toString() + ":" + iv.toString() + ":" + encrypted.toString();
  return result;
};

export const decryptPayload = (
  encryptedData: string,
  encryptionPass: string
) => {
  const parts = encryptedData.split(":");
  const salt = CryptoJS.enc.Hex.parse(parts[0]);
  const iv = CryptoJS.enc.Hex.parse(parts[1]);
  const encrypted = parts[2];

  const key = CryptoJS.PBKDF2(encryptionPass, salt, {
    keySize: 256 / 32,
    iterations: 1000,
  });

  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
  });

  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
};
